export class EditorConfig {
  static config() {
    return {
      readonly: false,
      toolbar: true,
      useInlineStyles: true,
      colorPickerDefaultTab: 'color' as const,
      useColorPickerDefaultColors: true,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      showPlaceholder: true,
      placeholder: 'Опис вакансії',
      events: {
        afterInit: (editor: any) => {
          const addNoFollowToLinks = () => {
            const links = editor.editor.querySelectorAll('a');
            links.forEach((link: HTMLAnchorElement) => {
              link.setAttribute('target', '_blank');
              link.setAttribute('rel', 'nofollow noopener noreferrer');
            });
          };

          const removeRefAttributes = () => {
            const elements = editor.editor.querySelectorAll('[ref]');
            elements.forEach((el: HTMLElement) => el.removeAttribute('ref'));
          };

          const sanitize = () => {
            addNoFollowToLinks();
            removeRefAttributes();
          };

          editor.events.on('paste', sanitize);
          editor.events.on('change', sanitize);
          editor.events.on('afterInsertLink', sanitize);
        },
      },
    };
  }
}
